import API from '@/services/typings'

import request, {METHODS} from '@/api'
import {trans} from '@/utils/common'
import UrlConfig from '@/api/UrlConfigs'
import {AxiosRequestConfig} from 'axios'
import {get} from 'lodash-es'
import {RequestConfig} from 'shj-utils'

//客户服务接口

/**
 * 保存周次配置
 * @param {object} data - 请求body数据对象
 * @returns
 */
export const httpAchievementWeekSave = (data: object) => {
  return request(`/plus-crm-web/achievementDateWeek`, {
    method: METHODS.POST,
    data,
  })
}
/**
 * 修改周次配置
 * @param {object} data - 请求body数据对象
 * @returns
 */
export const httpAchievementWeekUpdate = (data: object) => {
  return request(`/plus-crm-web/achievementDateWeek/updateById`, {
    method: METHODS.POST,
    data,
  })
}

/*
 * 获取周次配置
 * @param {string | number} id - 周次配置ID
 * @returns
 */
export const httpAchievementWeekDetails = (data?: any) => {
  return request(`/plus-crm-web/achievementDateWeek/search/list`, {
    method: METHODS.POST,
    data,
  })
}
/**
 * 获取日配置
 * @param {object} data - 请求body数据对象
 * @returns
 */
export const httpAchievementDateDaySave = (data: object) => {
  return request(`/plus-crm-web/achievementDateDay/saveOrUpdate`, {
    method: METHODS.POST,
    data,
  })
}
/**
 * 获取日配置
 * @param {object} data - 请求body数据对象
 * @returns
 */
export const httpAchievementDateDayUpdate = (data: object) => {
  return request(`/plus-crm-web/achievementDateDay/updateById`, {
    method: METHODS.POST,
    data,
  })
}

/**
 * 获取日配置
 * @param {object} data -
 * @returns
 */
export const httpAchievementDateDayDetails = (data?: {}) => {
  return request(`/plus-crm-web/achievementDateDay/search/list`, {
    method: METHODS.POST,
    data,
  })
}
/**
 * 获取数据字典
 * @param params 参数  { key: 'productionType', enable: '1' }
 * @returns
 */
export const httpDictServ = (
  data: { parentKey: string; enable: string | number } | { [key: string]: any }
) => {
  return new Promise(async resolve => {
    const resData: any = await request(UrlConfig.PlusProductWeb.GetDataDictionaryList, {
      method: METHODS.POST,
      data,
    })
    resolve(resData || [])
  })
}
/**
 * 获取公司列表
 * @param {string} data.companyType - 类型  group:集团  company:门店
 */
export const httpCompanyList = (data?: {}) => {
  return new Promise(async resolve => {
    const resData: any = await request(UrlConfig.Caas.GetCompanySearchList, {
      method: METHODS.POST,
      data: {
        enabled: true,
        orgType: 'COMPANY',
        ...data,
      },
    })
    resolve(resData)
  })
}

/**
 * 更新部门人员信息
 * @param {object} data - 请求参数
 * @returns
 */
export const httpAchievementDeptPersUpdate = async (data: { [key: string]: any }) => {
  return request(`/plus-crm-web/achievementPersonal/update`, {
    method: METHODS.POST,
    data,
  })
}

/**
 * 保存部门人员信息
 * @param {object} data - 请求参数
 * @returns
 */
export const httpAchievementDeptPersSave = async (data: { [key: string]: any }) => {
  return request(`/plus-crm-web/achievementPersonal/save`, {
    method: METHODS.POST,
    data,
  })
}

/**
 * 保存单条数据
 * @param data
 * @returns
 */
export const httpAchievementDeptPersSaveBatch = async (data: { [key: string]: any }) => {
  return request(`/plus-crm-web/achievementPersonal/saveBatch`, {
    method: METHODS.POST,
    data,
  })
}
/**
 * 显示单条信息
 * @param data
 * @returns
 */
export const httpAchievementShowForPersonal = async (id: string | number = '', params = {}) => {
  return request(`/plus-crm-web/achievementDepartment/achievementShowForPersonal/${id}`, {
    method: METHODS.POST,
    params,
  })
}
/**
 * 通过公司Code获取部门列表
 * @param {Array<any>} obj.companyCodes - 部门code集合
 * @param {Array<string>} obj.functionCodes - 默认参数，如：[marketing,design,YLmarketing]
 * @param {boolean} rest.enabled - 是否启用
 */
export const httpDeptFilter = ({
                                 companyCodes,
                                 functionCodes,
                                 ...rest
                               }: {
  [key: string]: any
}) => {
  if (companyCodes) {
    return new Promise(async resolve => {
      // const resData: any = await request(`/config-web/common/dept/filter/${depMentCode}/${paramsStr}`, {
      const resData: any = await request(UrlConfig.Caas.DepartmentSearchList, {
        method: METHODS.POST,
        data: {
          companyCodes,
          functionCodes,
          enabled: true,
          ...rest,
        },
      })
      resolve(resData)
    })
  }
}

/**
 * 获取部门人员列表数据集合
 * @param deptCode - 部门code
 * @returns
 */
export const httpAchievementPersonalDeptPersionList = async (data: any) => {
  return request(UrlConfig.Caas.EmployeeSearchList, {
    method: METHODS.POST,
    data,
  })
}

//标准版-客户服务 plus-crm-web

/**
 * 编辑
 * @param option
 */
export const updateById = (option?: API.Options) =>
  request(UrlConfig.PlusCrmWeb.EstateDeveloperUpdateById, {method: METHODS.POST, ...option})
/**
 * 检查开发商名称是否重名
 * @param name
 */
export const checkExistsByName = (name: string) =>
  request(`${UrlConfig.PlusCrmWeb.EstateDeveloperExistsByName}/${name}`, {method: METHODS.GET})
/**
 * 根据多个id删除
 * @param option
 */
export const deleteBatchIds = (option?: API.Options) =>
  request(UrlConfig.PlusCrmWeb.EstateDeveloper, {method: METHODS.DELETE, ...option})
/**
 * 新增
 * @param option
 */
export const insertOrUpdate = (option?: API.Options) =>
  request(UrlConfig.PlusCrmWeb.EstateDeveloper, {method: METHODS.POST, ...option})
/**
 * 开发商列表
 * @param option
 */
export const selectPageByQuery = (option?: API.Options) =>
  request(UrlConfig.PlusCrmWeb.EstateDeveloperSearchPage, {method: METHODS.POST, ...option})

/**
 *  标签管理 - 获取枚举值
 */
export const getEnum = (path: string) => {
  return request(`${UrlConfig.PlusCrmWeb.GetPlusEnums}${path}`, {
    method: METHODS.GET,
  })
    .then(res => {
      return res || []
    })
    .catch(() => [])
}

export const getTagTreeByType = (tagType = 'system', pid = 0) => {
  return request(`${UrlConfig.PlusCrmWeb.TagLibraryGetTagsTreeByType}${tagType}/${pid}`, {
    method: METHODS.GET,
  })
    .then((res: any) => {
      return {records: res || []}
    })
    .catch(() => [])
}
export const getTree = (pid = 0) => {
  return request(`${UrlConfig.PlusCrmWeb.TagLibraryGetTagsTree}${pid}`, {
    method: METHODS.GET,
  })
    .then((res: any) => {
      return res || []
    })
    .catch(() => [])
}

export const addTagType = params => {
  return request(UrlConfig.PlusCrmWeb.TagLibrary, {
    method: METHODS.POST,
    ...params,
  })
}

export const updateTagTypeOrTag = params => {
  return request(UrlConfig.PlusCrmWeb.TagLibraryUpdateById, {
    method: METHODS.POST,
    ...params,
  })
}

export const batchSaveTags = params => {
  return request(UrlConfig.PlusCrmWeb.TagLibraryBatchSaveTags, {
    method: METHODS.POST,
    ...params,
  })
}

export const deleteById = (id: string) => {
  return request(UrlConfig.PlusCrmWeb.TagLibrary + '/' + id, {
    method: METHODS.DELETE,
  })
}

//楼盘区域列表
export const buildingAreaList = (current: number, pageSize: number, data: object) => {
  return request(
    `${UrlConfig.PlusCrmWeb.BuildingAreaSearchPage}?pageId=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list')
    const total = get(resp, 'count', 0)
    return {records, total}
  })
}
//楼盘区域根据id查询信息
export const estateAreaById = (id: string | number) => {
  return request(`${UrlConfig.PlusCrmWeb.BuildingArea}/${id}`, {
    method: METHODS.GET,
  }).then((resp: any) => {
    return resp
  })
}

//楼盘区域新增or编辑
export const buildingAreaAddOrEdit = (id, data) => {
  return request(
    id ? UrlConfig.PlusCrmWeb.BuildingAreaUpdateById : UrlConfig.PlusCrmWeb.BuildingArea,
    {
      method: METHODS.POST,
      data,
      raw: true,
    }
  ).then((resp: any) => {
    return resp
  })
}
//  所有公司
export const getAllCompany = async (data: any) => {
  const resp: any = await request(UrlConfig.Caas.GetCompanyList, {
    method: METHODS.POST,
    data,
  })
  return resp?.list || []
}
//
export const getAllCompanyMrn = async (data: any) => {
  const resp: any = await request(UrlConfig.Caas.GetCompanyMrn, {
    method: METHODS.POST,
    data,
  })
  return resp || []
}
export const dispatchMnrSaveOrUpdateEntity = async (data: any) => {
  const resp: any = await request(UrlConfig.PlusCrmWeb.DispatchMnrSaveOrUpdateEntity, {
    method: METHODS.POST,
    data,
  })
  return resp || []
}
//楼盘信息--导出
export const exportBuildingInfoList = data => {
  return request(UrlConfig.PlusCrmWeb.BuildingInfoExportBuildingInfoList, {
    method: METHODS.POST,
    responseType: 'arraybuffer',
    data,
    raw: true,
  }).then((resp: any) => {
    return resp
  })
}
//下载批量添加模板
export const exportBuildingInfoTemplate = () => {
  return request(UrlConfig.PlusCrmWeb.BuildingInfoExportBuildingInfoTemplate, {
    method: METHODS.GET,
    responseType: 'arraybuffer',
    raw: true,
  }).then((resp: any) => {
    return resp
  })
}
// 楼盘列表
export const findBuildingInfoDtlPage = (current: number, pageSize: number, data: object) => {
  return request(
    `${UrlConfig.PlusCrmWeb.BuildingInfoSearchPage}?pageId=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list')
    const total = get(resp, 'count', 0)
    return {records, total}
  })
}

// 楼盘列表- 商品管理用
export const findBuildingPage = (options) => {
  return request(
    `${UrlConfig.PlusCrmWeb.BuildingInfoSearchPage}`,
    {
      method: METHODS.POST,
      ...options,
    }
  )
}
// /**
// * 参数配置
// * */
export const fetchGPList = (current, pageSize, data) => {
  return request(`/caas-web/generalParam/search/page`, {
    method: METHODS.POST,
    data,
    // raw: true,
    params: {
      pageId: current,
      pageSize,
    },
  })
}
//新增Or编辑楼盘
export const buildingInfoAddOrUpdate = (data, url) => {
  return request(`${UrlConfig.PlusCrmWeb.BuildingInfoOperate}${url}`, {
    method: METHODS.POST,
    data,
    raw: true,
  }).then((resp: any) => {
    return resp
  })
}

//楼盘信息详情户型信息列表
export const layoutInfoList = (current: number, pageSize: number, data: object) => {
  return request(
    `${UrlConfig.PlusCrmWeb.LayoutInfoSearchPage}?pageId=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list')
    const total = get(resp, 'count', 0)
    return {records, total}
  })
}
//楼盘信息详情户型信息列表删除
export const layoutInfoDel = (data: object) => {
  return request(UrlConfig.PlusCrmWeb.LayoutInfoOperate, {
    method: METHODS.DELETE,
    data,
  }).then((resp: any) => {
    return resp
  })
}
//楼盘信息详情列表根据id查询户型详情
export const layoutInfoSelectById = id => {
  return request(`${UrlConfig.PlusCrmWeb.LayoutInfoOperate}/${id}`, {
    method: METHODS.GET,
  }).then((resp: any) => {
    return resp
  })
}

//楼盘信息详情列表新增、修改
export const layoutInfoIOU = (data: object, url: string) => {
  return request(`${UrlConfig.PlusCrmWeb.LayoutInfoOperate}${url}`, {
    method: METHODS.POST,
    data,
    raw: true,
  }).then((resp: any) => {
    return resp
  })
}
//楼盘列表查询详情
export const buildingInfoByIdDetail = (data: object) => {
  return request(UrlConfig.PlusCrmWeb.BuildingInfoSearchOne, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
//根据公司id查询楼盘区域列表
export const areaFindListByCompanyCodeDetail = (data: object) => {
  return request(UrlConfig.PlusCrmWeb.BuildingAreaSearchList, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
//生成楼盘编号
export const getBuildingCodeDetail = () => {
  return request(UrlConfig.PlusCrmWeb.BuildingInfoGetBuildingCode, {
    method: METHODS.GET,
  }).then((resp: any) => {
    return resp
  })
}

//城市列表
export const findListByParentCode = (data: any) => {
  return request(`${UrlConfig.Platform.GetRegionList}${data.parentCode}/children`, {
    method: METHODS.GET,
  }).then((resp: any) => {
    return resp
  })
}
//城市列表
export const findRegionTree = () => {
  return request(`${UrlConfig.Platform.GetRegionTree}`, {
    method: METHODS.GET,
  }).then((resp: any) => {
    return resp
  })
}
export const getRegionLists = () => {
  return request(`${UrlConfig.Platform.GetRegionLists}`, {
    method: METHODS.GET,
  }).then((resp: any) => {
    return resp
  })
}

//开发部门
export const departmentSearchList = (data: object) => {
  return request(UrlConfig.Caas.DepartmentSearchList, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}

//开发商列表
export const estateDeveloperSearchList = (data: object) => {
  return request(UrlConfig.PlusCrmWeb.EstateDeveloperSearchList, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
//分配人删除
export const dispatchMnrDelete = (data: object) => {
  return request(UrlConfig.PlusCrmWeb.DispatchMnrDelete, {
    method: METHODS.POST,
    params: data,
  }).then((resp: any) => {
    return resp
  })
}
export const dispatchMnrFindResponseListByPage = (current, pageSize, data: any) => {
  return request(
    `${UrlConfig.PlusCrmWeb.DispatchMnrFindResponseListByPage}?current=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list')
    const total = get(resp, 'count', 0)
    return {records, total}
  })
}
/*
 *  业绩期管理 - 列表
 * */
export const httpAchievementDatePage = async (params: any, data: any) => {
  const resp = await request(UrlConfig.PlusCrmWeb.AchievementDatePage, {
    method: METHODS.POST,
    params,
    data,
  })
  const records = get(resp, 'list', [])
  const total = get(resp, 'count', 0)
  return {records, total}
}
/**
 * 目标管理 - 部门详情
 * @param id - 部门ID
 * @returns
 */
export const httpAchievementDeptDetails = async (id: string | number = '') => {
  return request(`${UrlConfig.PlusCrmWeb.AchievementDepartmentGetById}/${id}`, {
    method: METHODS.POST,
  })
}
/**
 * 目标管理 - 部门状态
 * @param data
 * @returns
 */
export const httpUpdateStatus = async (data: { [key: string]: any }) => {
  return request(UrlConfig.PlusCrmWeb.AchievementDepartmentUpdateStatus, {
    method: METHODS.POST,
    data,
  })
}

export const httpAchievementSaveOrUpdate = (dataOptions: RequestConfig) => {
  return request(`${UrlConfig.PlusCrmWeb.AchievementDate}/`, {
    method: METHODS.POST,
    ...dataOptions,
  })
}

/**
 * 目标周期配置 查询 get{id}
 * @param params
 * @returns
 */
export const httpAchievementDate = ({
                                      method = 'GET',
                                      params,
                                      data,
                                      id = '',
                                    }: {
  method?: 'GET' | 'POST' | 'DELETE'
  id?: string | number
} & AxiosRequestConfig) => {
  return request(`${UrlConfig.PlusCrmWeb.AchievementDateFindById}/${id}`, {
    method: METHODS[method],
    params,
    data,
  })
}
/**
 * 目标管理 - 删除部门
 * @param data
 * @returns
 */
export const httpAchieveDepartmentDelete = async (id: string | number) => {
  return request(`${UrlConfig.PlusCrmWeb.AchievementDepartment}/${id}`, {
    method: METHODS.DELETE,
  })
}
/**
 * 目标管理 - 更新部门
 * @param data
 * @returns
 */
export const httpAchieveDepartmentUpdate = async (data: { [key: string]: any }) => {
  return request(UrlConfig.PlusCrmWeb.AchievementDepartmentUpdate, {
    method: METHODS.POST,
    data,
  })
}
/**
 * 目标管理 - 新增部门
 * @param data
 * @returns
 */
export const httpAchieveDepartmentSave = async (data: { [key: string]: any }) => {
  return request(UrlConfig.PlusCrmWeb.AchievementDepartmentSave, {
    method: METHODS.POST,
    data,
  })
}
/**
 * 目标管理 - 新增部门
 * @param data
 * @returns
 */
export const httpAchieveDepartmentSaveBatch = async (data: { [key: string]: any }) => {
  return request(UrlConfig.PlusCrmWeb.AchievementDepartmentSaveBatch, {
    method: METHODS.POST,
    data,
  })
}
/**
 * 目标管理 - 新增部门
 * @param data
 * @returns
 */
export const httpAchieveDepartmentShowForDept = async (paramsStr: string = '', params) => {
  return request(`${UrlConfig.PlusCrmWeb.AchievementShowForDept}/${paramsStr}`, {
    method: METHODS.POST,
    params,
  })
}
/**
 * 获取周次配置列表
 */
export const httpAchievementDateList = (params?: { [key: string]: any }) => {
  return new Promise(async resolve => {
    const resData: any = await request(UrlConfig.PlusCrmWeb.AchievementDateList, {
      method: METHODS.GET,
      params,
    })
    resolve(resData)
  })
}
/**
 * 获取部门人员信息
 * @param {string | number} id - 部门人员信息ID
 * @returns
 */
export const httpAchievementPersonalDeptPersionDetails = async (id: any = '') => {
  return request(`${UrlConfig.PlusCrmWeb.AchievementPersonalGetById}/${id}`, {
    method: METHODS.POST,
  })
}

/**
 * 更新部门人员状态信息
 * @param {object} data - 请求参数
 * @returns
 */
export const httpAchievementDeptPersUpdateStatus = async (data: { [key: string]: any }) => {
  return request(UrlConfig.PlusCrmWeb.AchievementPersonalUpdateStatus, {
    method: METHODS.POST,
    data,
  })
}
/**
 * 删除部门人员信息
 * @param {string | number} id - 部门人员信息ID
 * @returns
 */
export const httpAchievementDeptPersDel = async (id: string | number = '') => {
  return request(`${UrlConfig.PlusCrmWeb.AchievementPersonal}/${id}`, {
    method: METHODS.DELETE,
  })
}
/**
 * 获取个人配置列表
 * @param {object} obj
 * @param {number} obj.current
 * @param {number} obj.pageSize
 * @param {object} obj.data - 请求参数
 * @returns
 */
export const httpAchievementPersonalList = async ({
                                                    current = 1,
                                                    pageSize = 10,
                                                    data,
                                                  }: {
  [key: string]: any
}) => {
  const resp = await request(
    `${UrlConfig.PlusCrmWeb.AchievementPersonalGetPageInfo}/${current}/${pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  )
  const records = get(resp, 'list', [])
  const total = get(resp, 'count', 0)
  return {records, total}
}
/**
 * 目标管理 - 部门列表
 * @param data
 * @returns
 */
export const httpAchievementDeptList = async (
  current: number,
  pageSize: number,
  data: { [key: string]: any }
) => {
  const resp = await request(
    `${UrlConfig.PlusCrmWeb.AchievementDepartmentGetPageInfo}/${current}/${pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  )
  const records = get(resp, 'list', [])
  const total = get(resp, 'count', 0)
  return {records, total}
}
/**
 * 获取详情目标配置
 */
export const httpAchievementDetails = (data?: { [key: string]: any }, id: string | number = '') => {
  return new Promise(async resolve => {
    const resData: any = await request(`${UrlConfig.PlusCrmWeb.AchievementManage}/${id}`, {
      method: METHODS.GET,
      data,
    })
    resolve(resData)
  })
}
/**
 * 问题列表导出
 */
export const exportAchievement = (params?: string) => {
  return request(UrlConfig.PlusCrmWeb.AchievementManageExport + params, {
    method: METHODS.GET,
    responseType: 'arraybuffer',
  })
}
/**
 * 同步目标周次配置  {achievementManageId}
 */
export const httpASyncAchievementDateWeekConfig = (id?: string | number) => {
  return request(`${UrlConfig.PlusCrmWeb.SynAchievementDateWeekConfig}/${id}` || '', {
    method: METHODS.GET,
  })
}
/**
 * 工单管理 - 问题列表
 */
export const httpAchievementList = async (
  current: number,
  pageSize: number,
  data: { [key: string]: any }
) => {
  const resp = await request(
    `${UrlConfig.PlusCrmWeb.AchievementManageSearch}?current=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: data,
    }
  )
  const records = get(resp, 'list', [])
  const total = get(resp, 'count', 0)
  return {records, total}
}
/**
 * 军种
 */
export const achievementChannelTypePage = (options) => {
  return request(UrlConfig.PlusCrmWeb.AchievementChannelTypePage, {
      method: METHODS.POST,
      ...options,
    })
}
export const achievementChannelTypeList = (data: { [key: string]: any }) => {
  return request(UrlConfig.PlusCrmWeb.AchievementChannelTypeList, {
      method: METHODS.POST,
      data,
    })
}
export const achievementChannelTypeUpdateById = (data: { [key: string]: any }) => {
  return request(UrlConfig.PlusCrmWeb.AchievementChannelTypeUpdateById, {
      method: METHODS.POST,
      data,
    })
}
export const addAchievementChannelType = (data?: { [key: string]: any }) => {
  return request(UrlConfig.PlusCrmWeb.AchievementChannelType, {
      method: METHODS.POST,
      data,
    })
}
export const delAchievementChannelType = (id) => {
  return request(UrlConfig.PlusCrmWeb.AchievementChannelType + '/' + id, {
      method: METHODS.DELETE,
    })
}

/**
 * 保存目标配置
 */
export const httpAchievementSave = (data?: { [key: string]: any }) => {
  return new Promise(async resolve => {
    const resData: any = await request(UrlConfig.PlusCrmWeb.AchievementManage, {
      method: METHODS.POST,
      data,
    })
    resolve(resData)
  })
}

/**
 * 修改
 * @param data
 * @returns
 */
export const httpAchievementUpdate = (data?: { [key: string]: any }) => {
  return new Promise(async resolve => {
    const resData: any = await request(UrlConfig.PlusCrmWeb.AchievementManageUpdateById, {
      method: METHODS.POST,
      data,
    })
    resolve(resData)
  })
}
// 线索

/**
 * 客户管理 - 线索列表
 * @param data
 * @returns
 */
export const clueInfoList = async (
  current: number,
  pageSize: number,
  data: { [key: string]: any }
) => {
  const resp = await request(
    `${UrlConfig.PlusClueWeb.ClueInfoList}?pageId=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  )
  const records = get(resp, 'list', [])
  const total = get(resp, 'count', 0)
  return {records, total}
}
/**
 *  营销公海池--客户来源
 */
export const getCustomerSource = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.TreeWithChannel, {method: METHODS.POST, data})
    .then(res => {
      return trans(res) || []
    })
}
/**
 *  线索分配异常的再次分配
 */
export const clueInfoDispatchClueAgain = (id) => {
  return request(UrlConfig.PlusClueWeb.ClueInfoDispatchClueAgain + id, {
    method: METHODS.POST,
  })
}
// 线索导入列表
export const clueImportPage = async (option: any) => {
  const {current, pageSize, data = {}} = option
  return await request(
    UrlConfig.PlusClueWeb.ClueInfoImportData + `?pageId=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: data,
    }
  )
}
// 下载模板
export const downloadExportTemplate = async () => {
  return await request(UrlConfig.PlusClueWeb.ExportTemplate, {
    method: METHODS.GET,
    responseType: 'arraybuffer',
  })
}
// 线索账号
export const launchAccountPage = async (option: any) => {
  const {current, pageSize, data = {}} = option
  return await request(
    UrlConfig.PlusClueWeb.LaunchAccountSearch + `?pageId=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  )
}
// 线索账号 -- 忽略权限
export const launchAccountPageWithoutPermission = async (option: any) => {
  const {current, pageSize, data = {}} = option
  return await request(
    UrlConfig.PlusClueWeb.LaunchAccountSearchWithoutPermission + `?pageId=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  )
}
// 客户列表
export const customerFindResponseListByPage = async (current, pageSize, data) => {
  const resp = await request(
    UrlConfig.PlusCrmWeb.CustomerFindResponseListByPage +
    `?current=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  )
  const records = get(resp, 'list', [])
  const total = get(resp, 'count', 0)
  return {records, total}
}
// 文件上传
export const clueImportUpload = async (option: any) => {
  const {accountId, formData, chargeFlag} = option
  return await request(UrlConfig.PlusClueWeb.ImportTemplate, {
    method: METHODS.POST,
    data: {
      accountId,
      chargeFlag,
      file: formData.get('file'),
    },
    headers: {'Content-Type': 'multipart/form-data'},
  })
}
//   派门店管理 字典查询

export const getDispatchMnrPage = (current, pageSize, data: any) => {
  return request(
    `${UrlConfig.PlusCrmWeb.DispatchMnrPage}?pageId=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list')
    const total = get(resp, 'count', 0)
    return {records, total}
  })
}
//   关闭管理 字典查询
export const getDataCloseTree = (data: any = {}) => {
  return request(UrlConfig.PlusCrmWeb.DataCloseTree, {
    method: METHODS.POST,
    data,
  })
}
// 需求标签枚举
export const getBizOpTypeEnum = () => {
  return request(UrlConfig.PlusCrmWeb.BizOpTypeEnum, {
    method: METHODS.GET,
  })
}
// 跟进任务管理枚举
export const getSalesTemplateTaskEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.SalesTemplateTaskEnum, {
    method: METHODS.GET,
  })
}

// 更新需求标签
export const updateBizType = (data) => {
  return request(UrlConfig.PlusCrmWeb.UpdateBizType, {
    method: METHODS.POST,
    data,
  })
}

// 查询画像已配置标签
export const getDrawTags = trackPlanId => {
  return request(`${UrlConfig.PlusCrmWeb.GetDrawTags}/${trackPlanId}`, {
    method: METHODS.GET,
  })
}

// 新增门店
export const addDispatchStore = data => {
  return request(UrlConfig.PlusCrmWeb.AddDispatchStore, {
    method: METHODS.POST,
    data,
  })
}
// 编辑门店
export const updateDispatchStore = data => {
  return request(UrlConfig.PlusCrmWeb.UpdateDispatchStore, {
    method: METHODS.POST,
    data,
  })
}
export const delDispatchStore = id => {
  return request(UrlConfig.PlusCrmWeb.DelDispatchStore + id, {
    method: METHODS.DELETE,
  })
}

// 销售计划新增
export const addNewTrackPlan = data => {
  return request(UrlConfig.PlusCrmWeb.AddNewTrackPlan, {
    method: METHODS.POST,
    data,
  })
}

// 销售计划编辑
export const updateTrackPlan = data => {
  return request(UrlConfig.PlusCrmWeb.UpdateTrackPlan, {
    method: METHODS.POST,
    data,
  })
}

// 新增跟进记录
export const addNewTrackLog = data => {
  return request(UrlConfig.PlusCrmWeb.AddNewTrackLog, {
    method: METHODS.POST,
    data,
  })
}

// 提交待定
export const submitPending = data => {
  return request(UrlConfig.PlusCrmWeb.SubmitPending, {
    method: METHODS.POST,
    data,
  })
}

// 新增有效
export const submitEffecive = data => {
  return request(UrlConfig.PlusCrmWeb.SubmitEffecive, {
    method: METHODS.POST,
    data,
  })
}

// 预约到店
export const subscribeArrive = data => {
  return request(UrlConfig.PlusCrmWeb.SubscribeArrive, {
    method: METHODS.POST,
    data,
  })
}

// 确认到店
export const confirmArrive = data => {
  return request(UrlConfig.PlusCrmWeb.ConfirmArrive, {
    method: METHODS.POST,
    data,
  })
}

// 转无效
export const submitInvalid = data => {
  return request(UrlConfig.PlusCrmWeb.SubmitInvalid, {
    method: METHODS.POST,
    data,
  })
}

// 详情统计
export const getTrackDetailCount = data => {
  return request(`${UrlConfig.PlusCrmWeb.GetTrackDetailCount}/${data.trackPlanId}`, {
    method: METHODS.GET,
    data,
  })
}

// 分tab数量统计
export const getTabPageCount = data => {
  return request(UrlConfig.PlusCrmWeb.GetTabPageCount, {
    method: METHODS.POST,
    data,
  })
}

// 跟进记录
export const getTrackPlanLog = data => {
  return request(UrlConfig.PlusCrmWeb.GetTrackPlanLog, {
    method: METHODS.POST,
    data,
  })
}

// 服务人员分配列表
export const getTrackPlanRelatives = data => {
  return request(UrlConfig.PlusCrmWeb.GetTrackPlanRelatives, {
    method: METHODS.POST,
    data,
  })
}

// 分配营销员
export const assignSales = data => {
  return request(UrlConfig.PlusCrmWeb.AssignSales, {
    method: METHODS.POST,
    data,
  })
}

// 分配设计师
export const assignDesigner = data => {
  return request(UrlConfig.PlusCrmWeb.AssignDesigner, {
    method: METHODS.POST,
    data,
  })
}

// 分配设计经理
export const assignDesignerMnr = data => {
  return request(UrlConfig.PlusCrmWeb.AssignDesignerMnr, {
    method: METHODS.POST,
    data,
  })
}

// 分配人员
export const assignRelatives = data => {
  return request(UrlConfig.PlusCrmWeb.AssignRelatives, {
    method: METHODS.POST,
    data,
  })
}

// 添加协作人
export const addPartner = data => {
  return request(UrlConfig.PlusCrmWeb.AddPartner, {
    method: METHODS.POST,
    data,
  })
}

// 移除协作人
export const removePartner = data => {
  return request(UrlConfig.PlusCrmWeb.RemovePartner, {
    method: METHODS.POST,
    data,
  })
}

// 获取操作按钮
export const getButtonList = trackPlanId => {
  return request(`${UrlConfig.PlusCrmWeb.GetButtonList}/${trackPlanId}`, {
    method: METHODS.POST,
  })
}

// 获取改派操作按钮
export const getButtonByTemplateId = salesTemplateId => {
  return request(`${UrlConfig.PlusCrmWeb.GetButtonByTemplateId}/${salesTemplateId}`, {
    method: METHODS.GET,
  })
}

// 订单列表
export const getOrderList = data => {
  return request(UrlConfig.PlusCrmWeb.GetOrderList, {
    method: METHODS.POST,
    data,
  })
}

// 查看电话
export const viewPhone = trackPlanId => {
  return request(`${UrlConfig.PlusCrmWeb.ViewPhone}/${trackPlanId}`, {
    method: METHODS.GET,
  })
}

// 查询授权人列表(分页)
export const getAuthorizeEmployee = async data => {
  return request(
    `${UrlConfig.PlusCrmWeb.GetAuthorizeEmployee}?pageId=${data.pageId}&pageSize=10`,
    {
      method: METHODS.POST,
      data,
    }
  )
}

// 查询授权人列表(分页)-变更
export const queryEmployeeForReassign = async data => {
  return request(
    `${UrlConfig.PlusCrmWeb.QueryEmployeeForReassign}?pageId=${data.pageId}&pageSize=10`,
    {
      method: METHODS.POST,
      data,
    }
  )
}

// 查询授权人列表(分页)-改派
export const getEmployee = async data => {
  return request(
    `${UrlConfig.PlusCrmWeb.GetEmployee}?pageId=${data.pageId || 1}&pageSize=${data.pageSize || 10}`,
    {
      method: METHODS.POST,
      data,
    }
  )
}

export const getTrackPlanNode = data => {
  return request(UrlConfig.PlusCrmWeb.GetTrackPlanNode, {
    method: METHODS.POST,
    data: {
      ...data,
      orderBys: [
        {
          columnName: "ID",
          asc: true
        }
      ]
    },
  })
}

export const updateTrackPlanTag = data => {
  return request(UrlConfig.PlusCrmWeb.UpdateTrackPlanTag, {
    method: METHODS.POST,
    data,
  })
}

// 预约见面-见面类型
export const appointmentTypeEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.AppointmentTypeEnum, {
    method: METHODS.GET,
  })
}

// 确认到店-是否到店
export const arrivalTypeEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.ArrivalTypeEnum, {
    method: METHODS.GET,
  })
}

// 功能需求
export const functionNeedEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.FunctionNeedEnum, {
    method: METHODS.GET,
  })
}

// 待定原因
export const pendingReasonEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.PendingReasonEnum, {
    method: METHODS.GET,
  })
}

// 客户信息编辑
export const updateCustomerInfo = data => {
  return request(UrlConfig.PlusCrmWeb.UpdateCustomerInfo, {
    method: METHODS.POST,
    data,
  })
}

// 建筑面积区间枚举
export const getContractAreaRangeEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.ContractAreaRangeEnum, {
    method: METHODS.GET,
  })
}

// 客户职业枚举
export const getCustomerCareerEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.CustomerCareerEnum, {
    method: METHODS.GET,
  })
}

// 装修风格枚举
export const getHouseDecorateStyleEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.HouseDecorateStyleEnum, {
    method: METHODS.GET,
  })
}

// 房屋类型枚举
export const getHouseKindEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.HouseKindEnum, {
    method: METHODS.GET,
  })
}

// 房屋属性枚举
export const getHouseNatureEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.HouseNatureEnum, {
    method: METHODS.GET,
  })
}

// 房屋状态枚举
export const getHouseStatusEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.HouseStatusEnum, {
    method: METHODS.GET,
  })
}

// 户型枚举
export const getHouseTypeEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.HouseTypeEnum, {
    method: METHODS.GET,
  })
}

// 常住人口枚举
export const getPermanentResidentsEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.PermanentResidentsEnum, {
    method: METHODS.GET,
  })
}

// 产品意向枚举
export const getProductionTypeEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.ProductionTypeEnum, {
    method: METHODS.GET,
  })
}

// 居住目的枚举
export const getResidencePurposeEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.ResidencePurposeEnum, {
    method: METHODS.GET,
  })
}

// 签单意向枚举
export const getSignBillIntentEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.SignBillIntentEnum, {
    method: METHODS.GET,
  })
}

// 新增跟进记录-跟进方式枚举
export const getAddRecordTypeEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.AddRecordTypeEnum, {
    method: METHODS.GET,
  })
}

// 客户状态
export const getTrackPlanStatusEnum = async () => {
  return request(UrlConfig.PlusCrmWeb.TrackPlanStatusEnum, {
    method: METHODS.GET,
  })
}

// 新增跟进记录-装修预算枚举
export const getBudGetEnums = async () => {
  return request(UrlConfig.PlusCrmWeb.BudGetEnums, {
    method: METHODS.GET,
  })
}

// 完整地区树
export const queryRegionCommons = async () => {
  return await request(UrlConfig.Platform.regionCommons, {
    method: METHODS.GET,
  });
}

// 获取客户信息详情
export const getCustomerMemberInfo = async (customerId: any) => {
  return request(`${UrlConfig.PlusCrmWeb.GetCustomerMemberInfo}/${customerId}`, {
    method: METHODS.GET,
  })
}

// 获取销售计划详情
export const getTrackPlanInfo = async (trackPlanId: any) => {
  return request(`${UrlConfig.PlusCrmWeb.GetTrackPlanInfo}/${trackPlanId}`, {
    method: METHODS.GET,
  })
}
// 商机列表- page
export const getNicheListByPage = (options) => {
  return request(UrlConfig.PlusCrmWeb.GetNicheListByPage, {
    method: METHODS.POST,
    ...options,
    timeout: 60 * 1000 * 1000
  })
}
// 公海池- page
export const getTrackPlanPage = (options) => {
  return request(UrlConfig.PlusCrmWeb.GetTrackPlanPage, {
    method: METHODS.POST,
    ...options,
  })
}
export const trackPlanUpdate = (data) => {
  return request(UrlConfig.PlusCrmWeb.TrackPlanUpdate, {
    method: METHODS.POST,
    data,
  })
}
export const trackPlanAdd = (data) => {
  return request(UrlConfig.PlusCrmWeb.TrackPlan, {
    method: METHODS.POST,
    data,
  })
}
// 公海池- 领取
export const getTrackPlanReceive = (data) => {
  return request(UrlConfig.PlusCrmWeb.GetTrackPlanReceive, {
    method: METHODS.POST,
    data,
  })
}
// 公海池- 详情- 客户会员信息
export const findCustomerMemberInfo = (customerId) => {
  return request(UrlConfig.PlusCrmWeb.FindCustomerMemberInfo + customerId, {
    method: METHODS.GET,
  })
}
// 公海池- 详情- 基本信息
export const trackPlanBaseInfo = (trackPlanId) => {
  return request(UrlConfig.PlusCrmWeb.TrackPlanBaseInfo + trackPlanId, {
    method: METHODS.GET,
  })
}

// 商机列表详情基础信息列表
export const getDetailByBizOpId = (id) => {
  return request(`${UrlConfig.PlusCrmWeb.GetDetailByBizOpId}/${id}`, {
    method: METHODS.POST,
  })
}

// 商机列表tag
export const queryAllTags = (id) => {
  return request(`${UrlConfig.PlusCrmWeb.QueryAllTags}/${id}`, {
    method: METHODS.GET,
  })
}
// 编辑分配人
export const saveDispatchUser = data => {
  return request(UrlConfig.PlusCrmWeb.SaveDispatchUser, {
    method: METHODS.POST,
    data,
  })
}

//   新增关闭管理数据
export const addDataClose = data => {
  return request(UrlConfig.PlusCrmWeb.AddDataClose, {
    method: METHODS.POST,
    data,
  })
}
//   删除关闭管理数据
export const deleteCloseData = id => {
  return request(UrlConfig.PlusCrmWeb.AddDataClose + '/' + id, {
    method: METHODS.DELETE,
  })
}
//修改关闭管理数据
export const dataCloseModify = data => {
  return request(UrlConfig.PlusCrmWeb.DataCloseModify, {
    method: METHODS.POST,
    data,
  })
}

//  报事报修- 对内
export const getTicketsInternalConfig = (options = {}) => {
  return request(UrlConfig.PlusCrmWeb.GetTicketsInternalConfig, {
    method: METHODS.POST,
    ...options,
  })
}
//  报事报修- 对内编辑
export const ticketsInternalConfigUpdate = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsInternalConfigUpdate, {
    method: METHODS.POST,
    data
  })
}
//  报事报修- 对内新增
export const ticketsInternalConfigAdd = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsInternalConfigAdd, {
    method: METHODS.POST,
    data
  })
}

//  报事报修- 对外
export const getTicketsExternalConfig = (options = {}) => {
  return request(UrlConfig.PlusCrmWeb.GetTicketsExternalConfig, {
    method: METHODS.POST,
    ...options,
    timeout: 60 * 1000 * 1000
  })
}
//  报事报修- 对外编辑
export const ticketsExternalConfigUpdate = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsExternalConfigUpdate, {
    method: METHODS.POST,
    data
  })
}
//  报事报修- 对外新增
export const ticketsExternalConfigAdd = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsExternalConfigAdd, {
    method: METHODS.POST,
    data
  })
}
//  报事报修- 渠道
export const getTicketsChannelConfig = (options = {}) => {
  return request(UrlConfig.PlusCrmWeb.GetTicketsChannelConfig, {
    method: METHODS.POST,
    ...options,
  })
}
//  报事报修- 渠道编辑
export const ticketsChannelConfigUpdate = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsChannelConfigUpdate, {
    method: METHODS.POST,
    data
  })
}
//  报事报修- 渠道新增
export const ticketsChannelConfigAdd = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsChannelConfigAdd, {
    method: METHODS.POST,
    data
  })
}
//  报事报修- 曝光渠道
export const getTicketsExposureConfig = (options = {}) => {
  return request(UrlConfig.PlusCrmWeb.GetTicketsExposureConfig, {
    method: METHODS.POST,
    ...options,
  })
}
//  报事报修- 曝光渠道编辑
export const ticketsExposureConfigUpdate = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsExposureConfigUpdate, {
    method: METHODS.POST,
    data
  })
}
//  报事报修- 曝光渠道新增
export const ticketsExposureConfigAdd = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsExposureConfigAdd, {
    method: METHODS.POST,
    data
  })
}
//  报事报修- 解决方案
export const getTicketsSolutionConfig = (options = {}) => {
  return request(UrlConfig.PlusCrmWeb.GetTicketsSolutionConfig, {
    method: METHODS.POST,
    ...options,
  })
}
//  报事报修- 解决方案编辑
export const ticketsSolutionConfigUpdate = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsSolutionConfigUpdate, {
    method: METHODS.POST,
    data
  })
}
//  报事报修- 解决方案新增
export const ticketsSolutionConfigAdd = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsSolutionConfigAdd, {
    method: METHODS.POST,
    data
  })
}
//  报事报修- 问题列表 - page
export const getTicketsIssueListPage = (options = {}) => {
  return request(UrlConfig.PlusCrmWeb.GetTicketsIssueListPage, {
    method: METHODS.POST,
    ...options,
  })
}
//  报事报修- 问题列表 - 新增编辑
export const ticketsIssueSaveOrUpdate = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsIssueSaveOrUpdate, {
    method: METHODS.POST,
    data
  })
}
//  报事报修- 问题列表 - 详情
export const ticketsIssueDetail = (id) => {
  return request(UrlConfig.PlusCrmWeb.TicketsIssueDetail + id, {
    method: METHODS.GET,
  })
}
//  报事报修- 问题列表 - 查看完整号码
export const ticketsIssueViewPhone = (params) => {
  return request(UrlConfig.PlusCrmWeb.TicketsIssueViewPhone, {
    method: METHODS.GET,
    params
  })
}
//  报事报修- 问题列表 - 推送评价
export const ticketsIssuePushComment = (params) => {
  return request(UrlConfig.PlusCrmWeb.TicketsIssuePushComment, {
    method: METHODS.GET,
    params
  })
}
//  报事报修- 问题列表 - 回复
export const ticketsIssueReplay = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsIssueReplay, {
    method: METHODS.POST,
    data
  })
}
//  报事报修-操作日志
export const ticketsOperateLog = (options) => {
  return request(UrlConfig.PlusCrmWeb.TicketsOperateLog, {
    method: METHODS.POST,
    ...options
  })
}

//  报事报修- 工单列表 - page
export const getTicketsListPage = (options = {}) => {
  return request(UrlConfig.PlusCrmWeb.GetTicketsListPage, {
    method: METHODS.POST,
    ...options,
  })
}
//  报事报修- 工单列表 - 根据问题ID查询工单列表
export const getTicketsListPageByIssue = (issueId) => {
  return request(UrlConfig.PlusCrmWeb.GetTicketsListByIssueId + issueId, {
    method: METHODS.GET,
  })
}

//  报事报修- 工单列表 - 新增编辑
export const ticketsSaveOrUpdate = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsSaveOrUpdate, {
    method: METHODS.POST,
    data
  })
}
//  报事报修- 工单列表 - 详情
export const ticketsDetail = (id) => {
  return request(UrlConfig.PlusCrmWeb.TicketsDetail + id, {
    method: METHODS.GET,
  })
}
//  报事报修- 工单列表 - 催办/批量催办
export const ticketsRemind = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsRemind, {
    method: METHODS.POST,
    data
  })
}
//  报事报修- 工单列表 - 退回
export const ticketsBack = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsBack, {
    method: METHODS.POST,
    data
  })
}
//  报事报修- 工单列表 - 批量修改处理人
export const ticketsBatchUpdateDisposePerson = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsBatchUpdateDisposePerson, {
    method: METHODS.POST,
    data
  })
}
//  报事报修- 工单详情 - 添加责任人
export const ticketsAddChargePerson = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsAddChargePerson, {
    method: METHODS.POST,
    data
  })
}
//  报事报修- 工单列表 - 重新打开
export const ticketsAnewOpen = (id) => {
  return request(UrlConfig.PlusCrmWeb.TicketsAnewOpen + id, {
    method: METHODS.GET,
  })
}
//  报事报修- 工单列表 - 受理
export const ticketsAccept = (id) => {
  return request(UrlConfig.PlusCrmWeb.TicketsAccept + id, {
    method: METHODS.GET,
  })
}
//  报事报修- 工单列表 /获取工单 角色 & 状态
export const ticketsGetLoginUserAttr = (id) => {
  return request(UrlConfig.PlusCrmWeb.TicketsGetLoginUserAttr,{
    method: METHODS.GET,
    params: {
      woId: id
    }
  })
}
//  报事报修- 工单列表 - 详情 - 处理记录
export const getTicketsDisposeLog = (data) => {
  return request(UrlConfig.PlusCrmWeb.GetTicketsDisposeLog, {
    method: METHODS.POST,
    data,
  })
}
//  报事报修- 工单列表 - 详情 - 处理记录
export const getTicketsDisposeTicketsClassify = (data) => {
  return request(UrlConfig.PlusCrmWeb.GetTicketsDisposeTicketsClassify, {
    method: METHODS.POST,
    data,
  })
}
//  报事报修- 工单列表 - 详情 - 处理记录
export const addTicketsDisposeLog = (data) => {
  return request(UrlConfig.PlusCrmWeb.AddTicketsDisposeLog, {
    method: METHODS.POST,
    data,
  })
}
//  报事报修- 工单列表 - 详情 - 回访记录
export const getTicketsCallbackLog = (data) => {
  return request(UrlConfig.PlusCrmWeb.GetTicketsCallbackLog, {
    method: METHODS.POST,
    data,
  })
}
//  报事报修- 工单列表 - 详情 - 回访记录 - 新增
export const ticketsCallbackLog = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsCallbackLog ,{
    method: METHODS.POST,
    data,
  })
}
//  报事报修- 报修列表
export const getTicketsRepairsListPage = (options) => {
  return request(UrlConfig.PlusCrmWeb.GetTicketsRepairsListPage, {
    method: METHODS.POST,
    ...options,
  })
}
//  报事报修- 报修列表 - 新增编辑
export const ticketsRepairsSave = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsRepairsSave, {
    method: METHODS.POST,
    data
  })
}
//  报事报修- 报修列表 - 回复
export const ticketsRepairsReplay = (data) => {
  return request(UrlConfig.PlusCrmWeb.TicketsRepairsReplay, {
    method: METHODS.POST,
    data
  })
}

//  分配人管理- 根据Id编辑数据
export const dispatchMnrUpdateById = (data) => {
  return request(UrlConfig.PlusCrmWeb.DispatchMnrUpdateById, {
    method: METHODS.POST,
    data
  })
}

//  派单方式
export const getDisPatchMethodList = (data = {}) => {
  return request(UrlConfig.DispatcherWeb.GetDisPatchMethodList, {
    method: METHODS.POST,
    data
  })
}
//  销售计划模板- page
export const getSalesTemplatePage = (options) => {
  return request(UrlConfig.PlusCrmWeb.GetSalesTemplatePage, {
    method: METHODS.POST,
    ...options
  })
}
//  销售计划模板- page
export const getSalesTemplateList = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.GetSalesTemplateSearchList, {
    method: METHODS.POST,
    data
  })
}
//  销售计划模板- save
export const salesTemplateSave = (data) => {
  return request(UrlConfig.PlusCrmWeb.SalesTemplateSave, {
    method: METHODS.POST,
    data
  })
}
//  销售计划模板- DELETE
export const salesTemplateDel = (id) => {
  return request(UrlConfig.PlusCrmWeb.SalesTemplateDel + id, {
    method: METHODS.DELETE,
  })
}
//  销售计划模板- 详情
export const salesTemplateDetail = (id) => {
  return request(UrlConfig.PlusCrmWeb.SalesTemplateDetail + id, {
    method: METHODS.GET,
  })
}
//  销售计划模板- Update
export const salesTemplateUpdate = (data) => {
  return request(UrlConfig.PlusCrmWeb.SalesTemplateUpdate, {
    method: METHODS.POST,
    data
  })
}
//  销售计划模板- Update
export const salesTemplateUpdateState = (data) => {
  return request(UrlConfig.PlusCrmWeb.SalesTemplateUpdateState, {
    method: METHODS.POST,
    data
  })
}
//  销售计划模板- Sort
export const salesTemplateSort = (data) => {
  return request(UrlConfig.PlusCrmWeb.SalesTemplateSort, {
    method: METHODS.POST,
    data
  })
}

// 查询营销员
export const querySalesMan = async (option: any) => {
  const { current = 1, pageSize = 10 } = option?.params
  return await request(UrlConfig.Clue.QuerySalesMan + `${current}/${pageSize}`, {
    method: METHODS.POST,
    data: option?.data,
  })
}

//楼盘列表(通过公司Code,handlflag是否处理查询结果)
export const getRealEstateList = async (option: any) => {
  if (!option.companyCode && !option.orgId) {
    return []
  }
  const resp = await request(UrlConfig.PlusCrmWeb.BuildingInfo, {
    // method: METHODS.GET,
    // params: { companyCode, ...(handlflag && { handlflag }) },
    method: METHODS.POST,
    data: { ...{ handlflag: option.handlflag ?? false }, ...option },
  })
  return resp || []
}
// 获取云客服回显列表
export const getAppointmentList = async (data: any) => {
  return request(`${UrlConfig.PlusCrmWeb.GetAppointmentList}`, {
    data,
    method: METHODS.POST,
  })
}
